"use client";

import { type JSX } from "react";
import { AtomicFacet, AtomicLayoutSection } from "@coveo/atomic-react";
import { ClientOnly } from "../../../atoms/ClientOnly";
import useIsMobile from "../../../hooks/useIsMobile";
import {
  type FacetResultsMustMatch,
  type FacetSortCriteria,
  type SearchFacetProps,
} from "./search-facet.props";

const FACET_STYLES = `
  @media (min-width: 1024px) {
    atomic-facet::part(value-checkbox-label) {
      max-width: 294px;
    }
  }
  atomic-facet::part(label-button):hover {
    color: inherit !important;
  }
`;

const VALID_SORT_CRITERIA = new Set<FacetSortCriteria>([
  "alphanumeric",
  "alphanumericDescending",
  "automatic",
  "occurrences",
  "score",
]);

const VALID_RESULTS_MUST_MATCH = new Set<FacetResultsMustMatch>([
  "allValues",
  "atLeastOneValue",
]);

const parseSortCriteria = (value: string | undefined): FacetSortCriteria =>
  value && VALID_SORT_CRITERIA.has(value as FacetSortCriteria)
    ? (value as FacetSortCriteria)
    : "automatic";

const parseResultsMustMatch = (
  value: string | undefined,
): FacetResultsMustMatch =>
  value && VALID_RESULTS_MUST_MATCH.has(value as FacetResultsMustMatch)
    ? (value as FacetResultsMustMatch)
    : "atLeastOneValue";

export const Default = (props: SearchFacetProps): JSX.Element => {
  console.log("---->[SearchFacet:Default] Component", props);

  const { fields, params } = props;
  const isMobile = useIsMobile();

  const id = params?.RenderingIdentifier;
  const numberOfValues = Number.parseInt(
    params?.NumberOfValues ? params?.NumberOfValues : "10",
    10,
  );
  const sortCriteria = parseSortCriteria(params?.SortCriteria);
  const resultsMustMatch = parseResultsMustMatch(params?.ResultsMustMatch);
  const searchable = params?.Searchable === "1";

  const fieldValue = fields?.Field?.value;

  return (
    <div
      id={id ?? undefined}
      className={`search-facet mt-(--spacing-thirtytwo) px-(--spacing-sixteen) last:mb-(--spacing-thirtytwo) ${params?.styles ?? ""}`}
      data-role="search-facet-component"
    >
      <ClientOnly>
        <AtomicLayoutSection section="facets">
          {fieldValue && (
            <>
              <style>{FACET_STYLES}</style>
              <AtomicFacet
                numberOfValues={numberOfValues}
                sortCriteria={sortCriteria}
                resultsMustMatch={resultsMustMatch}
                isCollapsed={isMobile}
                withSearch={searchable}
                label={fields?.Label?.value}
                field={fieldValue}
              />
            </>
          )}
        </AtomicLayoutSection>
      </ClientOnly>
    </div>
  );
};
